import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTriangleRightComponent } from "./med-icon-triangle-right.component";

@NgModule({
  declarations: [
    MedIconTriangleRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTriangleRightComponent,
  ],
})
export class MedIconTriangleRightModule { }
